import {
  makeGetRequest,
  makePostRequest,
  makePutRequest,
  makeDeleteRequest,
  makeLeadsGetRequest,
  makeLeadsPostRequest,
  makeLeadsPutRequest,
  makeLeadsDeleteRequest
} from 'utils/api'

const useAppBasedApi = app => {
  let getRequest, postRequest, putRequest, deleteRequest

  switch (app) {
    case 'leads':
      getRequest = makeLeadsGetRequest
      postRequest = makeLeadsPostRequest
      putRequest = makeLeadsPutRequest
      deleteRequest = makeLeadsDeleteRequest
      break
    default:
      getRequest = makeGetRequest
      postRequest = makePostRequest
      putRequest = makePutRequest
      deleteRequest = makeDeleteRequest
  }

  return {
    getRequest,
    postRequest,
    putRequest,
    deleteRequest
  }
}

export default useAppBasedApi
